import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext({
  user: null,
  role: null,
  logout: () => {}
});

export const AuthProvider = ({children}) => {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);

  useEffect(() => {
    const storedUser = JSON.parse(sessionStorage.getItem("lgusr"));
    
    if (storedUser) {
      setUser(storedUser);
      setRole(storedUser.role);
    }
  }, [])

  const logout = () => {
    setUser(null);
    setRole(null);
    sessionStorage.removeItem("lgusr");
  }
  return (
    <AuthContext.Provider value={{ user, role, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
